import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const ProWrapper = styled.div`
  display: grid;
  height: auto;
  background:linear-gradient(#000000,#242424);
  grid-template-columns: 100%;
    overflow-x: hidden;
  overflow-y: visible;
  grid-template-rows: auto auto auto auto;
  grid-template-areas: 'title'
                       'estimate'
                       'score'
                       'tabs'
                       'button'; 
                       
  @media (min-width: ${breakpoints.desktop}) {
    background:linear-gradient(#383838,#2a2a2a);
    grid-template-columns: 50% 50%;
    border-radius: 0;
    padding: 0;
    margin: 0;
    grid-template-rows: 85px 120px 180px auto auto auto auto;
    grid-template-areas: 'header header' 
                        'title title'
                       'estimate score'
                       'tabs tabs'
                       'tabs tabs'
                       'tabs tabs'
                       'button button';
    //                   
    //                   grid-template-rows: auto 55px auto auto auto auto;
    //grid-template-areas: 'brand chart' 
    //                    'title chart'
    //                   'estimate chart'
    //                   'forecast chart'
    //                   'score chart'
    //                   'table table';                          
  }
`;

export const Header = styled.div`
  grid-area: header;
  
  @media (min-width: ${breakpoints.desktop}) {
    border-bottom: 2px #7f7f7f solid;
    background-color: black;
    display: flex;
    width: 100%;
  }
`;

export const TitleWrapper = styled.div`
  grid-area: title;
  position: relative;
  background-color: rgba(255,255,255,0.2);
  flex-direction: row;
  display: flex;
  
  @media (min-width: ${breakpoints.desktop}) {
    background-color: transparent;
    flex-direction: column;
  }
`;

export const YMM = styled.h2`
  font-family: 'Roboto', sans-serif;
  text-align: left;
  color: white;
  font-size: 14px;
  margin: 5px 15px 10px 15px;
  flex-direction: column;
  display: flex;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 15px 30px 0 25px;
    font-size: 1.6rem;
    flex-direction: row;
  }
`;

export const YearMakeTitle = styled.span`
  font-weight: 600;
  margin: 5px 0;
  color: white;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 5px 5px 5px 0;
    color: #bfbfbf;
  }
`;

export const ModelTitle = styled.span`
  font-weight: 300;
  color: white;
  
  @media (min-width: ${breakpoints.desktop}) {
    margin: 5px 0px;
    color: #bfbfbf;
  }
`;

export const AttributesWrapper = styled.div`
  flex-direction: column;
`;

export const Vin = styled.p`
  color: white;
  font-size: 14px;
  display: flex;
  margin: 0 0 15px 15px;
  @media (min-width: ${breakpoints.desktop}) {
    margin: 0 0 0 25px;
  }
`;

export const SearchAgain = styled.div`
  flex-direction: row;
  position: absolute;
  top: 18px;
  right: 15px;
  cursor: pointer;
  
  @media (min-width: ${breakpoints.desktop}) {
    top: 20px;
    right: 20px;
    background-color: #5e5e5e;
    padding: 10px;
    border-radius: 5px;
  }
`;

export const ButtonsWrapper = styled.div`
  grid-area: button;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  
  @media (min-width: ${breakpoints.desktop}){

  }
`;

export const ClickToConsign = styled.div`
  @media (min-width: ${breakpoints.desktop}) {

  }
`;

export const SearchAgainText = styled.span`
  color: white;
  margin: 0 10px 0 0;
  display: none;
  font-size: 14px;
  
   @media (min-width: ${breakpoints.desktop}) {
    display: inline;
  }
`;

export const Brand = styled.a`
  grid-area: brand;
  display: none;
  
  @media (min-width: ${breakpoints.desktop}) {
    display: inline;
    padding: 15px 15px 0 15px;
  }
`;

export const NPALogo = styled.img`
  border: 0;
  display: flex;
  position: absolute;
  right: 15px;
  width: 200px;
  top: 15px;
  object-fit: contain;
  display: none;
  
  @media (min-width: ${breakpoints.desktop}) {
    display: inline;
  }
`;

export const TabWrapper = styled.div`
grid-area: tabs;
display: flex;
flex-direction: column;
overflow: hidden;

  @media (min-width: ${breakpoints.desktop}){
   
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  grid-area: tabs;
  z-index: 10;

  @media (min-width: ${breakpoints.desktop}){
    z-index: 10;
    text-align: right;
    grid-area: tabs;
    display: flex;
    flex-direction: row;
    margin-right: 40px;
    align-items: center;
    justify-items: center;
  }
`;

export const SelectBox = styled.select`
width: 150px;

  @media (min-width: ${breakpoints.desktop}){
    
    padding: 10px;
    width: 300px;
    text-align: center;
    margin: 5px 5px;
  }
`;
